<template>
  <div class="big">
    <div class="page_title flex_between">
      <span>商品详情</span>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px">
      <div class="container">
        <el-form
          :model="form"
          style="min-width: 1000px"
          label-width="100px"
          ref="ruleForm"
          class="nomarginform"
        >
          <el-form-item label="商品排序">
            <span>
              {{ form.sort }}
            </span>
            <span style="margin-left: 10px; color: #999"
              >数字越大，排名越靠前,如果为空，默认排序方式为创建时间</span
            >
          </el-form-item>
          <el-form-item label="商品名称">
            <span>
              {{ form.goods_name }}
            </span>
          </el-form-item>
          <el-form-item label="商品编码">
            <span>
              {{ form.goods_code }}
            </span>
          </el-form-item>
          <el-form-item label="平台类目" prop="category">
            <el-cascader
              v-model="form.category"
              :options="categoryList"
              :props="{ expandTrigger: 'hover', multiple: true }"
              placeholder="选择后台分类"
              disabled
            ></el-cascader>
          </el-form-item>
          <el-form-item label="商品类型">
            <span v-if="form.goods_type == 1">实体商品</span>
            <span v-if="form.goods_type == 2">虚拟商品</span>
          </el-form-item>
          <el-form-item label="开启售后">
            <span v-if="form.is_service == 1">是</span>
            <span v-if="form.is_service == 0">否</span>
          </el-form-item>
          <el-form-item label="轮播图片" prop="img_id_array">
            <div style="color: #999">商品详情页轮播图片</div>
          </el-form-item>
          <div class="imgList flex">
            <div class="box" v-for="item in form.img_id_array" :key="item">
              <el-image
                :src="item"
                style="height: 300px; margin-right: 20px"
              ></el-image>
            </div>
          </div>
          <el-form-item label="商品视频">
            <div v-if="form.video_url_str">
              <video
                :src="form.video_url_str"
                style="width: 150px; height: 120px"
                :poster="form.mian_url_str"
                controls
                @click="openPreview"
              ></video>
            </div>
          </el-form-item>
          <el-form-item label="商品价格">
            <span>
              {{ form.price }}
            </span>
            <span v-if="form.price">元</span>
          </el-form-item>
          <el-form-item label="成本价">
            <span>
              {{ form.cost_price }}
            </span>
            <span v-if="form.cost_price">元</span>
          </el-form-item>
          <el-form-item label="会员价格">
            <span>
              {{ form.member_price }}
            </span>
            <span v-if="form.member_price">元</span>
          </el-form-item>
          <el-form-item label="商品数量">
            <span>
              {{ form.stock }}
            </span>
            <span v-if="form.stock"
              >件
              <span style="margin-left: 10px; color: #999">拍下减库存</span>
            </span>
          </el-form-item>
          <el-form-item label="商品重量">
            <span>
              {{ form.goods_weight }}
            </span>
            <span v-if="form.goods_weight">件 </span>
          </el-form-item>
          <el-form-item label="限时售卖">
            <span v-if="form.limit_time_start">
              <span>{{ form.limit_time_start }}</span>
              <span>~</span>
              <span>{{ form.limit_time_start }}</span>
              <span style="color: #999; margin-left: 15px"
                >超过限售时间时，商品自动下架</span
              >
            </span>
          </el-form-item>
          <el-form-item label="当前状态">
            <span v-if="form.state == 1">下架</span>
            <span v-if="form.state == 2">正常</span>
            <span v-if="form.state == 5">暂存仓库</span>
            <span v-if="form.state == 6">自动下架</span>
          </el-form-item>
          <el-form-item label="虚拟出售数">
            <span>
              {{ form.sales }}
            </span>
            <span v-if="form.sales">件 </span>
            <span style="margin-left: 10px; color: #999"
              >初始的基础出售数量</span
            >
          </el-form-item>

          <el-form-item label="运费设置" prop="shipping_fee_id">
            <span v-if="form.shipping_fee_type == 1">
              <span>统一运费：</span>
              <span>{{ form.shipping_fee }}元</span>
            </span>
            <span v-if="form.shipping_fee_type == 2">
              <span>运费模板：</span>
              <span>{{ form.shipping_fee_id }}</span>
            </span>
          </el-form-item>
          <el-form-item label="商品详情"> </el-form-item>
          <div class="imgList flex">
            <div class="box" v-for="item in form.description" :key="item">
              <el-image
                :src="item"
                style="height: 300px; margin-right: 20px"
              ></el-image>
            </div>
          </div>
          <el-form-item label="启用商品规格">
            <span v-if="form.open_spec == 1">是</span>
            <span v-if="form.open_spec == 0">否</span>
          </el-form-item>
          <el-form-item label="启用积分抵扣">
            <span v-if="form.integral_price > 0">是</span>
            <span v-else>否</span>
            <span style="margin-left: 30px" v-if="form.integral_price > 0">
              设置积分抵扣金额
              <el-input
                v-model="form.integral_price"
                maxlength="64"
                disabled
                style="width: 60px"
              ></el-input>
              元
            </span>
          </el-form-item>
          <div class="lineH-box">
            <div class="lineH"></div>
            <div>推荐商品</div>
          </div>
          <div style="display: flex">
            <div
              class="recommendBox"
              v-for="(i, index) in form.recommend_list"
              :key="index"
            >
              <div class="itemBox">
                <img :src="i.picture" alt="" />
              </div>
              <div class="title">{{ i.goods_name }}</div>
            </div>
          </div>
          <div class="lineH-box">
            <div class="lineH"></div>
            <div>商品参数</div>
          </div>
          <div class="table-info">
            <div class="info-row">
              <div
                class="info-list"
                v-for="(item, index) in form.parameter_content"
                :key="index"
              >
                <div class="info-head">{{ item.name }}：</div>
                <div class="info-details">{{ item.value }}</div>
              </div>
            </div>
          </div>
          <!-- 第一个规格 -->
          <template v-if="form.spec_list[0] && form.spec_list[0].spec_name">
            <div class="spec_title flex align-center">
              <div class="name">规格:{{ form.spec_list[0].spec_name }}</div>
            </div>
            <div class="box_content flex wrap">
              <div
                class="spec_box flex align-center"
                v-for="(item, index) in form.spec_list[0].value"
                :key="item.spec_value_id"
              >
                <el-form-item
                  label=""
                  label-width="0"
                  :prop="'spec_list[0].value.' + index + '.spec_value_name'"
                  class="flex align-center"
                >
                  <el-input
                    v-model="item.spec_value_name"
                    placeholder="填写规格值"
                    maxlength="64"
                    disabled
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </template>
          <!-- 第二个规格 -->
          <template v-if="form.spec_list[1] && form.spec_list[1].spec_name">
            <div class="spec_title flex align-center">
              <div class="name">规格:{{ form.spec_list[1].spec_name }}</div>
            </div>
            <div class="box_content flex wrap">
              <div
                class="spec_box flex align-center"
                v-for="(item, index) in form.spec_list[1].value"
                :key="item.spec_value_id"
              >
                <el-form-item
                  label=""
                  label-width="0"
                  :prop="'spec_list[1].value.' + index + '.spec_value_name'"
                  class="flex align-center"
                >
                  <el-input
                    v-model="item.spec_value_name"
                    placeholder="填写规格值"
                    maxlength="64"
                    disabled
                  ></el-input>
                </el-form-item>
              </div>
            </div>
          </template>
          <!-- sku列表 -->
          <div
            class="sku_box flex wrap"
            v-for="(item, index) in form.sku_list"
            :key="index"
          >
            <el-form-item label="" label-width="0">
              <div class="title">{{ item.sku_name }}：</div>
            </el-form-item>
            <el-form-item
              label="价格（元）"
              :prop="'sku_list.' + index + '.price'"
            >
              <el-input-number
                v-model="item.price"
                step-strictly
                :step="0.01"
                :max="1000000000000"
                :controls="false"
                disabled
              ></el-input-number>
            </el-form-item>
            <el-form-item label="成本价">
              <el-input-number
                v-model="item.cost_price"
                step-strictly
                :step="0.01"
                :max="1000000000000"
                :controls="false"
                disabled
              ></el-input-number>
            </el-form-item>
            <el-form-item label="会员价">
              <el-input-number
                v-model="item.member_price"
                step-strictly
                :step="0.01"
                :max="1000000000000"
                :controls="false"
                disabled
              ></el-input-number>
            </el-form-item>
            <el-form-item label="数量" :prop="'sku_list.' + index + '.stock'">
              <el-input-number
                v-model="item.stock"
                step-strictly
                :step="1"
                :max="1000000000000"
                :controls="false"
                disabled
              ></el-input-number>
            </el-form-item>
            <el-form-item label="商品编码">
              <el-input
                v-model="item.goods_code"
                disabled
                class="myinput"
                maxlength="20"
                style="width: 120px"
              ></el-input>
            </el-form-item>
            <el-form-item label="重量（g）">
              <el-input-number
                v-model="item.weight"
                step-strictly
                :max="1000000000000"
                :controls="false"
                disabled
              ></el-input-number>
            </el-form-item>
          </div>
        </el-form>
        <!-- 图片预览 -->
        <el-image-viewer
          v-if="showViewer"
          :on-close="
            () => {
              showViewer = false;
            }
          "
          :url-list="imgList"
        />
      </div>
    </div>
    <!-- 模态框 -->
    <div
      v-if="isPreviewVisible"
      class="preview-modal"
      @click.self="closePreview"
      style="z-index: 999"
    >
      <video
        ref="previewPlayer"
        width="800"
        height="450"
        :poster="chooseVideo.mian_url_str"
        controls
        @click.stop
      >
        <source :src="chooseVideo.video_url_str" type="video/mp4" />
      </video>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      goods_id: this.$route.query.goods_id,
      form: {
        sort: undefined,
        goods_name: "",
        goods_code: "",
        category: [],
        goods_type: "1",
        goods_weight: undefined,
        img_id_array: [],
        price: undefined,
        cost_price: undefined,
        member_price: undefined,
        stock: undefined,
        limit_time: [],
        state: "2",
        sales: undefined,
        shipping_fee_type: "1",
        shipping_fee: undefined,
        shipping_fee_id: "",
        description: [],
        open_spec: 1,
        spec_list: [], //规格列表
        sku_list: [], //sku列表
        parameter_content: [],
        video_url_str: "",
      },
      specForm: {
        spec_name: "", //规则名
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      categoryList: [],
      open_spec: true, //是否启用规格
      historyImgShow: false, //历史图片弹窗
      showViewer: false, //图片预览
      imgList: [], //预览图片列表
      feeList: [], //运费模板列表

      specShow: false,
      isPreviewVisible: false,
      chooseVideo: {}, //符合条件的视频
    };
  },
  watch: {
    //判断能否开启规格
    "form.sku_list": {
      handler(newValue, oldValue) {
        if (newValue.length == 0) {
          this.open_spec = true;
          this.form.open_spec = false;
        } else {
          this.open_spec = false;
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getGoodsInfo();
    this.getCategoryList();
    // this.getShippingFee();
  },
  methods: {
    getGoodsInfo() {
      let data = {
        goods_id: this.goods_id,
      };
      this.axios.post("platform/shop/getGoodsInfo", data).then((res) => {
        let info = res.data.info;
        let form = {
          sort: info.sort,
          goods_name: info.goods_name,
          goods_code: info.goods_code,
          goods_type: info.goods_type.toString(),
          goods_weight: info.goods_weight || undefined,
          img_id_array: info.img_id_array_str || [],
          price: info.price || undefined,
          cost_price: info.cost_price || undefined,
          member_price: info.member_price || undefined,
          stock: info.stock || undefined,
          limit_time_start: info.limit_time_start
            ? dayjs.unix(info.limit_time_start).format("YYYY-MM-DD HH:mm")
            : "",
          limit_time_end: info.limit_time_end
            ? dayjs.unix(info.limit_time_end).format("YYYY-MM-DD HH:mm")
            : "",
          state: info.state.toString(),
          sales: info.sales || undefined,
          shipping_fee_type: info.shipping_fee_type.toString(),
          shipping_fee: info.shipping_fee,
          shipping_fee_id: info.shipping_fee_id || "",
          description: info.description_str || [],
          open_spec: info.open_spec,
          spec_list: info.spec_value_items || [],
          sku_list: info.sku_list || [],
          is_service: info.is_service,
          parameter_content: info.parameter_content,
          video_url_str: info.video_url_str,
          recommend_list: info.recommend_list,
        };
        this.chooseVideo = {
          mian_url: info.mian_url,
          mian_url_str: info.mian_url_str,
          video_url: info.video_url,
          video_url_str: info.video_url_str,
        };
        let category_id_list_arr = info.category_id_list.map((el) => {
          return [el.category_id_1, el.category_id_2];
        });
        console.log("category_id_list_arr", category_id_list_arr);
        let category = category_id_list_arr;
        form.category = category;
        if (form.member_price == 0) {
          form.member_price = undefined;
        }
        if (form.cost_price == 0) {
          form.cost_price = undefined;
        }
        form.sku_list.forEach((ele) => {
          if (ele.member_price == 0) {
            ele.member_price = undefined;
          }
          if (ele.cost_price == 0) {
            ele.cost_price = undefined;
          }
          if (ele.weight == 0) {
            ele.weight = undefined;
          }
        });
        this.form = form;
      });
    },
    //平台分类列表
    getCategoryList() {
      this.axios
        .post("platform/ManageGoods/getGoodsCategoryList")
        .then((res) => {
          let list = res.data.list;
          let arr = [];
          list.forEach((ele) => {
            if (ele.child.length == 0) {
              arr.push({
                value: ele.category_id,
                label: ele.category_name,
              });
            } else {
              let childArr = [];
              ele.child.forEach((e) => {
                childArr.push({
                  value: e.category_id,
                  label: e.category_name,
                });
              });
              arr.push({
                value: ele.category_id,
                label: ele.category_name,
                children: childArr,
              });
            }
          });
          this.categoryList = arr;
        });
    },

    //查看图片
    showImg(item) {
      this.imgList = [item];
      this.showViewer = true;
    },
    //删除图片
    delImg(item, type) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let list = type == 1 ? this.form.img_id_array : this.form.description;
          list.splice(
            list.findIndex((ele) => item == ele),
            1
          );
        })
        .catch(() => {});
    },
    //从历史记录中选择图片
    chooseImg(imgData) {
      let length1 = this.form.img_id_array.length;
      let length2 = imgData.length;
      if (length1 + length2 > 5) {
        this.$message.error("选择后幻灯片图片总数量超过5个！");
        return;
      } else {
        let arr = imgData.map((ele) => {
          return ele.pic_url_str;
        });
        this.form.img_id_array = this.form.img_id_array.concat(arr);
        this.historyImgShow = false;
      }
    },
    //添加规格
    addSpec() {
      let length = this.form.spec_list.length;
      if (length >= 2) {
        this.$message.error("最多添加两种规格");
        return;
      }
      this.specShow = true;
    },
    //确认添加规格
    specConfirm() {
      let check = false;
      this.$refs.specForm.validate((valid) => {
        check = valid;
      });

      if (!check) {
        return;
      }
      let obj = {
        spec_name: this.specForm.spec_name,
        spec_id: -new Date().getTime(),
        value: [
          {
            spec_value_name: "",
            spec_value_id: -new Date().getTime(),
            picture: "",
          },
        ],
      };
      this.form.spec_list.push(obj);
      this.specForm.spec_name = "";
      this.specShow = false;
    },
    //删除规格
    delSpec(type) {
      this.$confirm("确认要删除整个规格吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (type == 1) {
            this.form.spec_list.splice(0, 1);
          } else {
            this.form.spec_list.splice(1, 1);
          }
          this.form.sku_list = [];
          this.$message.success("删除成功！");
        })
        .catch(() => {});
    },
    //添加规格子项
    addSpecChild(type) {
      let obj = {
        spec_value_name: "",
        spec_value_id: -new Date().getTime(),
        picture: "",
      };
      if (type == 1) {
        this.form.spec_list[0].value.push(obj);
      }
      if (type == 2) {
        this.form.spec_list[1].value.push(obj);
      }
    },
    //删除规格子项
    delSpecChild(type, id) {
      this.$confirm("确认删除规格吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let list = [];
          if (type == 1) {
            list = this.form.spec_list[0].value;
          } else if (type == 2) {
            list = this.form.spec_list[1].value;
          }
          let index = list.findIndex((ele) => {
            return ele.spec_value_id == id;
          });
          list.splice(index, 1);
          this.setSkuList();
        })
        .catch(() => {});
    },
    //改变sku列表
    setSkuList() {
      let newValue = JSON.parse(JSON.stringify(this.form.spec_list));
      if (!newValue[0]) {
        return;
      }
      let arr1 =
        newValue[0].value.filter((ele) => {
          return ele.spec_value_name;
        }) || [];
      let arr2 = [];
      if (newValue[1]) {
        arr2 =
          newValue[1].value.filter((ele) => {
            return ele.spec_value_name;
          }) || [];
      }
      if (arr1.length == 0) {
        this.form.sku_list = [];
        return;
      }
      let sku_list = [];
      arr1.forEach((arr1_ele) => {
        if (arr2.length == 0) {
          let origin = this.form.sku_list.find((sku_ele) => {
            return sku_ele.sku_name == arr1_ele.spec_value_name;
          });
          if (origin) {
            //如果有已经填了的值 直接覆盖不新增
            origin.picture = arr1_ele.picture;
            sku_list.push(origin);
          } else {
            let obj = {
              sku_name: arr1_ele.spec_value_name,
              price: undefined,
              member_price: undefined,
              cost_price: undefined,
              stock: undefined,
              picture: arr1_ele.picture,
              goods_code: "",
              weight: undefined,
            };
            sku_list.push(obj);
          }
        } else {
          arr2.forEach((arr2_ele) => {
            let origin = this.form.sku_list.find((sku_ele) => {
              return (
                sku_ele.sku_name ==
                arr1_ele.spec_value_name + " " + arr2_ele.spec_value_name
              );
            });
            if (origin) {
              //如果有已经填了的值 直接覆盖不新增
              origin.picture = arr1_ele.picture;
              sku_list.push(origin);
            } else {
              let obj = {
                sku_name:
                  arr1_ele.spec_value_name + " " + arr2_ele.spec_value_name,
                price: undefined,
                member_price: undefined,
                stock: undefined,
                cost_price: undefined,
                picture: arr1_ele.picture,
                goods_code: "",
                weight: undefined,
                sku_id: -new Date().getTime(),
              };
              sku_list.push(obj);
            }
          });
        }
      });
      this.form.sku_list = sku_list;
    },
    //获取运费模板列表
    getShippingFee() {
      this.axios
        .post("/store/Shopshipping/getShopShippingList", {
          page: 1,
          pageNumber: 100,
        })
        .then((res) => {
          this.feeList = res.data.list;
        });
    },
    //去新建运费模板
    toAddFreight() {
      let routeData = this.$router.resolve({
        path: "/system/addFreight",
      });
      window.open(routeData.href, "_blank");
    },

    //返回
    back() {
      history.back();
    },
    openPreview() {
      // 点击视频时打开预览模态框
      this.isPreviewVisible = true;

      // 监听全局点击事件，以便在点击模态框外部时关闭预览
      window.addEventListener("click", this.globalClickHandler);
    },
    closePreview() {
      // 关闭预览模态框
      this.isPreviewVisible = false;

      // 移除全局点击事件监听器
      window.removeEventListener("click", this.globalClickHandler);

      // 重置预览视频的播放状态
      this.$refs.previewPlayer.currentTime = 0;
      this.$refs.previewPlayer.pause();
    },
    globalClickHandler(event) {
      // 在全局点击事件处理程序中检查点击的区域是否在预览模态框之外
      const previewModal = this.$refs.previewModal;
      if (previewModal && !previewModal.contains(event.target)) {
        this.closePreview();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-input,
.el-input-number,
.el-cascader {
  width: 250px;
  margin-right: 5px;
}
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  border-radius: 5px;
  text-align: left;
}
.imgList {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0 20px 100px;
  margin-top: -20px;
  .box {
    position: relative;
    &:hover .shadow {
      display: flex;
    }
    .shadow {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.6);
      display: none;
    }
    i + i {
      margin-left: 30px;
      color: #d44747;
    }
    i {
      color: #ffffff;
      font-size: 30px;
      text-align: center;
      cursor: pointer;
    }
  }
}
.spec_title {
  margin-bottom: 10px;
  .name {
    font-weight: bold;
    margin-right: 10px;
    font-size: 18px;
  }
  span {
    margin-left: 10px;
  }
}
.spec_add {
  color: #1890ff;
  font-size: 16px;
  box-sizing: border-box;
  padding-top: 7px;
  cursor: pointer;
  i {
    margin-right: 5px;
  }
}
.spec_box {
  width: 310px;
  margin-right: 50px;

  i {
    font-size: 25px;
    margin-top: -20px;
    cursor: pointer;
    color: #aaaaaa;
  }
  i + div {
    margin-top: -10px;
    margin-left: 5px;
    img {
      width: 25px;
      height: 25px;
      margin-top: -10px;
    }
  }
}
.sku_box {
  margin: 15px 0;
  .title {
    font-weight: bold;
    width: 100px;
  }
  .el-input,
  .el-input-number,
  .el-cascader {
    width: 100px;
    margin-right: 5px;
  }
}
.submit {
  margin: 30px 0;
}
</style>
<style lang="scss">
.nomarginform .el-form-item {
  margin-bottom: 10px;
}
.el-form-item__content {
  height: auto;
}
.lineH-box {
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #606266;
  font-weight: 700;
  margin-bottom: 20px;
  .lineH {
    width: 3px;
    height: 18px;
    background: #4974f5;
    border-radius: 21px;
    margin-right: 8px;
  }
}
.table-info {
  width: 80%;
  padding: 10px 11px;
  .info-row {
    display: flex;
    flex-wrap: wrap;
    .info-list {
      width: 50%;
      display: flex;
      margin-bottom: 10px;
    }
  }
}
.preview-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
}

.preview-modal video {
  max-width: 100%;
  max-height: 100%;
}

.chooseVideoBox {
  position: relative;
  .closed {
    position: absolute;
    right: 0;
    top: 0;
    font-size: 20px;
    z-index: 99;
  }
}
.recommendBox {
  margin-right: 10px;
  width: 150px;
  .itemBox {
    width: 150px;
    height: 150px;
    position: relative;
    img {
      width: 150px;
      height: 150px;
    }
  }
  .title {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
  }
}
</style>
